module.exports = __webpack_public_path__ + "static/img/÷cone Negativo.c852ef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_transparente/÷cone Negativo.png
// module id = 258
// module chunks = 0